import { Account } from 'model/IChat';

export const getHost = (
  hosts: Account[],
  account: Account,
  forceHost?: string,
) => {
  if (forceHost) {
    let host = hosts.find((host) => host.id === forceHost);
    if (!host && account.id === forceHost) {
      host = account;
    } else if (!host) {
      host = hosts[0];
    }
    return host || account;
  }

  return hosts[0] || account;
};
